import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoIconComponent } from './go-icon.component';

@NgModule({
  declarations: [GoIconComponent],
  imports: [
    CommonModule
  ],
  exports: [GoIconComponent]
})

export class GoIconModule { }
